var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.091,
    height: 61.892,
    viewBox: "27.351 25.815 61.091 61.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m68.011 30.635-13.958 8.34 16.377 2.226 13.467-8.4-15.886-2.166Zm3.232 24.747c8.927 0 16.162 7.237 16.162 16.164 0 8.925-7.235 16.161-16.162 16.161-8.926 0-16.162-7.236-16.162-16.161 0-8.927 7.236-16.164 16.162-16.164Zm-4.161 13.883 2.408 2.258 5.532-5.62c.54-.549.881-.99 1.548-.304l2.163 2.217c.711.703.675 1.115.005 1.769l-8.012 7.864c-1.411 1.386-1.167 1.47-2.599.05l-4.688-4.66c-.298-.324-.264-.65.062-.975l2.51-2.604c.381-.399.683-.365 1.07.005ZM52.13 41.074l-.011 17.143-6.224-4.239-6.225 3.517.738-18.014-10.711-1.456v37.862l21.648 2.8c.305.857.661 1.69 1.07 2.494l-23.939-3.096a1.174 1.174 0 0 1-1.125-1.172V36.686c.033-.49.229-.833.692-1.065l21.383-9.702a1.19 1.19 0 0 1 .635-.094l37.281 5.086c.616.071 1.038.577 1.038 1.209v.002l.062 27.675c-.692-1.024-1.884-2.455-2.411-3.36V34.231l-14.01 9.064v7.235a21.152 21.152 0 0 0-2.345.044v-7.116L52.13 41.074Zm-9.862-3.7 13.57-8.4-5.756-.785-17.379 7.885 9.565 1.3Z",
    fill: "#37b0e3",
    fillRule: "evenodd",
    "data-name": "product-package-delivered-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderBox);
export default __webpack_public_path__ + "static/media/OrderBox.45da1872d18071065782193ed32e6371.svg";
export { ForwardRef as ReactComponent };